import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.step, _defineProperty({}, _vm.$style.currentStep, _vm.isCurrentStep), _defineProperty({}, _vm.$style.passedStep, _vm.isPassedStep)]
  }, [_c('span', {
    class: _vm.$style.iconWrapper
  }, [_vm.hasIcon ? _c('SIcon', {
    class: _vm.$style.icon,
    attrs: {
      "size": "12",
      "icon": "i-".concat(_vm.iconName)
    }
  }) : [_vm._v("\n      " + _vm._s(_vm.index + 1) + "\n    ")]], 2), _vm._v(" "), _c('span', {
    class: _vm.$style.label
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };